import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CompanyService } from 'src/app/services/company/company.service';
import { ForumService } from 'src/app/services/forum/forum.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { AddImportantNoticeComponent } from '../../add-important-notice/add-important-notice.component';
import { AddForumComponent } from '../add-forum/add-forum.component';
import { DeleteItemComponent } from '../../delete-item/delete-item.component';
import { PaginationInstance } from 'ngx-pagination';
import { AppService } from 'src/app/services/app/app.service';
import { Filter } from '../../filter/filter.model';
import { NgxPermissionsService } from 'ngx-permissions';
import { CommonService } from 'src/app/services/common/common.service';

@Component({
  selector: 'app-forum-management',
  templateUrl: './forum-management.component.html',
  styleUrls: ['./forum-management.component.scss']
})
export class ForumManagementComponent {
  public imageUrl = GlobalService.serverURL;
  public filteredItems: any[] = []
  public pageSizeOptions = GlobalService.pageSizeOptions;
  public maxPaginationSize = GlobalService.maxPaginationSize;
  public count !: number;
  public config: PaginationInstance = {
    itemsPerPage: this.pageSizeOptions[0],
    currentPage: 1,
  };
  public isSpinnerLoading: boolean = false
  public isFilterShow :boolean=false;
  private animationConfig: {} = { enterAnimationDuration: '300ms', exitAnimationDuration: "300ms" }
  public filterObj:Filter={
    operand:"or",
    arr:[]
  }
  public filterArr:any[]=[
    { key_name: "Title", key_val: "tit", type: 'text' },
    { key_name: "Department", key_val: "d_i", type: 'select' },
  ]
  public searchInput: string = '';
  private previousInputValue: string = '';

  constructor(private _liveAnnouncer: LiveAnnouncer, public dialog: MatDialog, private router: Router, private companyService: CompanyService,
    private spinner: NgxSpinnerService, private forumService: ForumService, private appService: AppService,private permissionsService: NgxPermissionsService,
    private commonService:CommonService ) { }
  ngOnInit(): void {
    this.commonService.setTitle("Forum Management")
    const perm = ["forum_management"];

    this.permissionsService.loadPermissions(perm);
    this.list()
  }
  onAddEditForum(item) {
    let obj = {
      width: '95%',
      minWidth: '300px',
      height: '98%',
      maxHeight: '700px',
      maxWidth: '772px',
      enterAnimationDuration: '300ms',
      exitAnimationDuration: "300ms",
      panelClass: "hire",
      autoFocus: false
    }
    if (item) {
      obj["data"] = item;
    }
    const dialogRef = this.dialog.open(AddForumComponent, obj);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result["data_added"] == true) {
          this.list()
        }
      }
    });
  }
  onDeleteForum(id: number) {
    const dialogRef = this.dialog.open(DeleteItemComponent, Object.assign({
      data: { api_type: "delete_content", content_type: "delete_forum", id: id }
    }, this.animationConfig));
    dialogRef.afterClosed().subscribe(result => {
      if (result && (result["delete_content"] == true)) {
        this.list()
      }
    });
  }
 onSearch(event: any) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue == '' && this.previousInputValue !== '') {
      this.config.currentPage=0
      this.list()
    }
  }
  callApi(obj){
    this.filterObj=obj
    this.list()
  }
  list() {
    // this.spinner.show();
    this.isSpinnerLoading = true
    let obj={
      sh: this.searchInput.trim(),
      st: this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
      r_p: this.config.itemsPerPage,
      f_a: this.filterObj.arr,
      op_nd: this.filterObj.operand
    }
    this.forumService.list(obj).subscribe({
        next: (success: any) => {
          if (success.status == 200) {
            this.previousInputValue = this.searchInput;
            this.isSpinnerLoading = false;
            // this.dataSource = new MatTableDataSource<PeriodicElement>(success.data.listArr);
            this.count = success.count
            if (success.is_approve) {
              // this.filteredItems = success.data.listArr;
              this.filteredItems = success.data;
            } else {
              // this.dataSource = [];
            }
          }
        },
           error:(error:any)=>{
            this.commonService.handleError(error)
           }
         }
    );
  }
  onPageSizeChange(event: Event) {
    const tar = event.target as HTMLInputElement
    this.config.itemsPerPage = Number(tar.value)
    this.config.currentPage = 1
    this.list()
  }
  onPageChange(number: number) {
    this.list()
  }
  onFilterView(){
    this.isFilterShow = !this.isFilterShow;
    if (!this.isFilterShow && this.filterObj.arr.length > 0) {
      this.filterObj.arr = [];
      this.list()
    }
  }
  onGo(){
    if(this.searchInput.trim()!=''){
      this.config.currentPage=0
      this.list()
    }
  }
}
